var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85447 19.7584C15.8794 19.7584 19.721 13.7908 19.721 8.61608C19.721 8.44651 19.7177 8.2777 19.7101 8.1098C20.4558 7.5571 21.104 6.86742 21.6154 6.08215C20.9311 6.39381 20.1946 6.60393 19.4221 6.69868C20.2106 6.21393 20.816 5.44676 21.1015 4.53238C20.3634 4.98094 19.5464 5.30726 18.6765 5.48287C17.9795 4.72173 16.9869 4.24561 15.8886 4.24561C13.7793 4.24561 12.0688 5.99946 12.0688 8.16149C12.0688 8.46888 12.1024 8.76764 12.1679 9.05441C8.99386 8.89079 6.17914 7.3324 4.29571 4.96285C3.9674 5.54143 3.77842 6.21393 3.77842 6.93117C3.77842 8.28984 4.45274 9.48923 5.47801 10.1909C4.85156 10.1711 4.26294 9.9946 3.74819 9.70095C3.74737 9.71729 3.74737 9.73371 3.74737 9.75089C3.74737 11.6477 5.064 13.2311 6.81146 13.5902C6.49068 13.6797 6.15315 13.728 5.80467 13.728C5.55857 13.728 5.31925 13.703 5.08671 13.6573C5.57287 15.2132 6.98272 16.3454 8.65461 16.3773C7.34714 17.4277 5.7005 18.0537 3.91111 18.0537C3.60292 18.0537 3.29896 18.0356 3 17.9994C4.69035 19.1101 6.69724 19.7584 8.85447 19.7584Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e47eb0f992e4d9df378d88ae321d1736.svg";
export { ForwardRef as ReactComponent };